// @ts-nocheck
/* eslint-disable */
export const boldInfoCircleIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M14.667 8A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.334 0M8 11.833a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-1 0v4a.5.5 0 0 0 .5.5m0-7.166A.667.667 0 1 1 8 6a.667.667 0 0 1 0-1.333" clip-rule="evenodd"/></svg>`,
    name: 'bold-info-circle' as const
};